import { DashboardNotifications } from '@dev/ee-api/ee-api-models';

import {
    DashboardSeenNotificationsActionTypes,
    UpdateDashboardSeenNotificationAction,
    GetDashboardSeenNotificationsAction,
    GetDashboardSeenNotificationsSuccessAction,
} from './types';
import { ApplicationState } from '..';

export const GetDashboardSeenNotifications = (): GetDashboardSeenNotificationsAction => ({
    type: DashboardSeenNotificationsActionTypes.GET_DASHBOARD_SEEN_NOTIFICATIONS,
});

export const UpdateDashboardSeenNotification = (
    notification: DashboardNotifications
): UpdateDashboardSeenNotificationAction => ({
    type: DashboardSeenNotificationsActionTypes.UPDATE_DASHBOARD_SEEN_NOTIFICATION,
    payload: {
        notification,
    },
});

export const GetDashboardSeenNotificationsSuccess = (
    notifications: DashboardNotifications[]
): GetDashboardSeenNotificationsSuccessAction => ({
    type: DashboardSeenNotificationsActionTypes.GET_DASHBOARD_SEEN_NOTIFICATIONS_SUCCESS,
    payload: {
        notifications,
    },
});

export const getDashboardSeenNotificationsStore = (store: ApplicationState) => store?.dashboardSeenNotifications;
